import { API } from "./axiosInstance"


/**
 * Gets all the contacts with joined tables from usermanagement-service
 * @returns the contacts with joined objects
 */
export const getContactpersonen= async () => {
    const contactpersonen = await API.get(`/contacts?isDeleted=0`);
    return contactpersonen.data;
}

/**
 * Gets all the contact with joined tables for one member from usermanagement-service
 * @param {*} staticMemberId The static member to get all the contacts for
 * @returns the contacts with joined objects
 */
export const getContactpersonenForMember= async (staticMemberId) => {
    const contactpersonen = await API.get(`/contacts?memberId=${staticMemberId}&isDeleted=0`);
    return contactpersonen.data;
}

/**
 * Calls the post contacts endpoint
 * @param {*} contactpersoon the contact to create
 * @returns the response from usermanagement-service
 */
export const createContactpersoon = async (contactpersoon) => {
    const gecreerdeContactpersoon = await API.post('/contacts', contactpersoon);
    return gecreerdeContactpersoon;
}

/**
 * Calls the update contacts endpoint
 * @param {*} contactpersoon the contactpersoon to update
 * @returns the updated contact
 */
export const updateContactpersoon = async (contactpersoon, staticId, extended = false) => {
    try {
        const gecreerdeContactpersoon = await API.put(`/contacts/${staticId}`, contactpersoon);
        return gecreerdeContactpersoon;
    } catch (error) {
        if (extended) {
            // Return the error to the caller for multi edit purposes
            throw new Error(
                `Fout bij updaten contactpersoon met ID ${staticId}: ${error.message}`
            );
        } else {
            // Handle the error internally for default behaviour
            throw err;
        }
    }
};

/**
 * Accepts a requested change for a contact
 * @param {*} staticId the id of the contact in the static model
 * @returns the accepted contact
 */
export const acceptChange = async(staticId) => {
    const response = await API.post(`/contacts/${staticId}/accept`);
    return response.data;
}

/**
 * Rejects a requested change for a contact
 * @param {*} staticId the id of the contact in the static model
 * @returns the rejected contact
 */
export const rejectChange = async(staticId) => {
    const response = await API.post(`/contacts/${staticId}/reject`);
    return response.data;
}